import { render, staticRenderFns } from "./testQuery.vue?vue&type=template&id=24309bcc&scoped=true"
import script from "./testQuery.vue?vue&type=script&lang=js"
export * from "./testQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24309bcc",
  null
  
)

export default component.exports